import { createSlice } from '@reduxjs/toolkit';

const initializeSlice = createSlice({
  name: 'initialized',
  initialState: { complete: false, temporary: false },

  reducers: {
    initializeSuccess: state => {
      state.complete = true;
    },
    initializeTemporarySuccess: state => {
      state.temporary = true;
    },
    revokeTemporarySuccess: state => {
      state.temporary = false;
    },
  },
});

const { initializeSuccess, initializeTemporarySuccess, revokeTemporarySuccess } = initializeSlice.actions;
export { initializeSuccess, initializeTemporarySuccess, revokeTemporarySuccess };

export default initializeSlice;
